(function () {
  'use strict';

  function init() {
    initRebuy();
    hookPplrAfterCart();
  }

  // 1. Run the Rebuy experiment
  function initRebuy() {
    if (typeof RebuyExperiments !== 'undefined') {
      RebuyExperiments.run('new-cart-25472');
    } else {
      var attempts = 0;
      var poll = setInterval(function () {
        if (typeof RebuyExperiments !== 'undefined') {
          clearInterval(poll);
          RebuyExperiments.run('new-cart-25472');
        } else if (++attempts > 20) {
          clearInterval(poll);
        }
      }, 500);
    }
  }

  // 2. Update header cart count badge
  var nativeFetch = window.fetch.bind(window);
  function updateCartCount() {
    nativeFetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
      var badges = document.querySelectorAll('.cart-count');
      badges.forEach(function (badge) {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          badge.classList.remove('hidden-count');
        } else {
          badge.classList.add('hidden-count');
        }
      });
    }).catch(function () {});
  }

  // 3. Open the Rebuy Smart Cart drawer with retry
  function openSmartCart(retries) {
    retries = retries || 0;
    if (retries === 0) updateCartCount();
    var r = window.Rebuy;
    var smartCart = r && (r.SmartCart || r.smart_cart);
    if (smartCart && typeof smartCart.show === 'function') {
      if (r.Cart && typeof r.Cart.fetchCart === 'function') {
        r.Cart.fetchCart().then(function () { smartCart.show(); });
      } else {
        smartCart.show();
      }
      return;
    }
    if (retries === 0) {
      document.dispatchEvent(new CustomEvent('rebuy:smartcart.show'));
    }
    if (retries < 10) {
      setTimeout(function () { openSmartCart(retries + 1); }, 300);
    }
  }

  // 4. AJAX add-to-cart helper
  function ajaxAddToCart(formData) {
    return nativeFetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
      return res.json();
    });
  }

  // 5. Intercept form submissions to /cart/add
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    e.stopPropagation();

    ajaxAddToCart(new FormData(form))
      .then(function () { openSmartCart(0); })
      .catch(function (err) { console.error('[Rebuy Cart] submit error:', err); });
  }, true);

  // 6. Intercept fetch calls to /cart/add and /cart/change
  function isCartMutationUrl(url) {
    return url.indexOf('/cart/add') !== -1
      || url.indexOf('/cart/change') !== -1
      || url.indexOf('/cart/update') !== -1
      || url.indexOf('/cart/clear') !== -1;
  }

  window.fetch = function (url, opts) {
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
    if (urlStr.indexOf('/cart/add') !== -1) {
      return nativeFetch.apply(this, arguments).then(function (res) {
        var clone = res.clone();
        clone.json().then(function () { openSmartCart(0); }).catch(function () {});
        return res;
      });
    }
    if (isCartMutationUrl(urlStr)) {
      return nativeFetch.apply(this, arguments).then(function (res) {
        updateCartCount();
        return res;
      });
    }
    return nativeFetch.apply(this, arguments);
  };

  // 7. Intercept XHR calls to /cart/add and /cart/change
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var urlStr = typeof url === 'string' ? url : '';
    this._cartAdd = urlStr.indexOf('/cart/add') !== -1;
    this._cartMutation = isCartMutationUrl(urlStr);
    return xhrOpen.apply(this, arguments);
  };
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._cartAdd) {
      this.addEventListener('load', function () { openSmartCart(0); });
    } else if (this._cartMutation) {
      this.addEventListener('load', function () { updateCartCount(); });
    }
    return xhrSend.apply(this, arguments);
  };

  // 8. Dismiss PPLR "adding to cart" overlay
  function dismissPplrOverlay() {
    var overlay = document.querySelector('.poverlay-bg.addtocartbg');
    if (overlay) overlay.style.display = 'none';
  }

  // 9. Fix preview links in Rebuy Smart Cart
  function fixPreviewLinkOnRebuyCart() {
    var UPLOAD_URL = /^https:\/\/cdn\.shopify\.com\/s\/files\/[^\s]+\/uploads\/[^\s]+$/;
    function fixPreviewLinks() {
      var spans = document.querySelectorAll('.rebuy-cart__flyout-item-property.property-key-preview .rebuy-cart__flyout-item-property-value');
      spans.forEach(function (span) {
        if (span.querySelector('a')) return;
        var url = span.textContent.trim();
        if (!UPLOAD_URL.test(url)) return;
        var link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'Uploaded File';
        link.style.cursor = 'pointer';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          window.open(url, '_blank', 'noopener');
        });
        span.textContent = '';
        span.appendChild(link);
      });
    }
    var observer = new MutationObserver(function () { fixPreviewLinks(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // 10. Override ZeptoApps Product Personalizer redirect
  function hookPplrAfterCart() {
    if (typeof window.pplr_after_cart === 'function') {
      window.pplr_after_cart = function () { dismissPplrOverlay(); openSmartCart(0); };
      return;
    }
    var pplrAttempts = 0;
    var pplrPoll = setInterval(function () {
      if (typeof window.pplr_after_cart === 'function') {
        clearInterval(pplrPoll);
        window.pplr_after_cart = function () { dismissPplrOverlay(); openSmartCart(0); };
      } else if (++pplrAttempts > 30) {
        clearInterval(pplrPoll);
      }
    }, 500);
  }

  // Init
  init();
  fixPreviewLinkOnRebuyCart();
})();
